const BASE_IMG_W_PX = 432;
const BASE_IMG_H_PX = 360;

// Shiny SVG inner pitch bounds (px in the 432x360 viewBox)
const INNER_LEFT_PX = 8.22;
const INNER_TOP_PX = 42.75;
const INNER_RIGHT_PX = 306.59; // 8.22 + 298.37
const INNER_BOTTOM_PX = 332.34; // 42.75 + 289.59

// Linear mapping from dx/dy (metres) to normalized pitch coords (0..1)
// Fitted from Setanta13 Shiny SVG points + CSV rows
const X_PCT_OFFSET = 0.5;
const X_PCT_SCALE = 0.01069526;
const Y_PCT_OFFSET = 0.04547583;
const Y_PCT_SCALE = 0.0110189;

export const getShotMapCalibration = () => {
  const INNER_LEFT_PCT = INNER_LEFT_PX / BASE_IMG_W_PX;
  const INNER_TOP_PCT = INNER_TOP_PX / BASE_IMG_H_PX;
  const INNER_WIDTH_PCT = (INNER_RIGHT_PX - INNER_LEFT_PX) / BASE_IMG_W_PX;
  const INNER_HEIGHT_PCT = (INNER_BOTTOM_PX - INNER_TOP_PX) / BASE_IMG_H_PX;

  return {
    BASE_IMG_W_PX,
    BASE_IMG_H_PX,
    INNER_LEFT_PX,
    INNER_TOP_PX,
    INNER_RIGHT_PX,
    INNER_BOTTOM_PX,
    INNER_LEFT_PCT,
    INNER_TOP_PCT,
    INNER_WIDTH_PCT,
    INNER_HEIGHT_PCT,
    X_PCT_OFFSET,
    X_PCT_SCALE,
    Y_PCT_OFFSET,
    Y_PCT_SCALE,
  };
};
